import React, { useRef, useState } from "react";
import { IconExternalLink } from "@tabler/icons-react";
import { useAuth } from "../../../../Auth/AuthProvider";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);
import RequestItemMenu from "./RequestItemMenu";
import StatusIcon from "./RequestItemIcons";
import RequestItemShareButton from "../RequestItemShareButton/RequestItemShareButton";
import { formatPayload, hasPayload } from "../../../../utils/requestPayload";

export default function RequestItem(props) {
  const { uid } = useAuth();
  const [isExpanded, setIsExpanded] = useState(false);
  const requestUrlRef = useRef(null);
  const requestPayloadRef = useRef(null);

  const requestUrl =
    window.location.origin +
    "/s/" +
    uid +
    "." +
    props.request_id +
    "." +
    props.urlKey;

  return (
    <div className="relative mb-3 border border-mauve-200 bg-white">
      <div
        role="button"
        tabIndex={0}
        onClick={() => setIsExpanded(!isExpanded)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") setIsExpanded(!isExpanded);
        }}
        aria-controls={props.request_id + "-collapse-info"}
        aria-expanded={isExpanded}
        className={`cursor-pointer px-4 py-3 transition-colors duration-300 ${isExpanded ? "bg-mauve-50" : "bg-white"}`}
      >
        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
          <div>
            <small className="text-mauve-500">Request title</small>
            <div className="text-mauve-900">{props.title}</div>
          </div>
          <div className="hidden md:block">
            <small className="text-mauve-500">To</small>
            <div className="text-mauve-900">{props.recipient}</div>
          </div>
          <div className="hidden lg:block">
            <small className="text-mauve-500">Sent</small>
            <div className="text-mauve-900">
              {dayjs.unix(Math.floor(props.created_at / 1000)).fromNow()}
            </div>
          </div>
          <div>
            <small className="text-mauve-500">Status</small>
            <div className="flex flex-row items-center gap-2">
              <StatusIcon variant="open" value={props.opened_at} />
              <StatusIcon
                variant="reply"
                value={hasPayload(props.payload)}
                repliedAt={props.replied_at}
              />
            </div>
          </div>
        </div>
      </div>

      <RequestItemMenu visible={isExpanded} uid={uid} {...props} />

      <div
        id={props.request_id + "-collapse-info"}
        className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
          isExpanded ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
        aria-hidden={!isExpanded}
      >
        <div
          className="min-h-0 overflow-hidden"
          {...(!isExpanded ? { inert: "" } : {})}
        >
          <div
            className={`border-t border-mauve-100 px-4 py-3 transition-opacity duration-300 ${
              isExpanded ? "opacity-100" : "opacity-0"
            }`}
          >
            <div className="mb-3">
              <small className="text-mauve-500">Request link</small>
              <div className="mt-1 flex">
                <input
                  readOnly
                  type="text"
                  value={requestUrl}
                  ref={requestUrlRef}
                  className="min-w-0 flex-1 border border-r-0 border-mauve-200 bg-white px-3 py-2 text-sm text-mauve-900"
                />
                <div className="flex shrink-0 [&>*+*]:border-l-0">
                  <RequestItemShareButton
                    shareData={{
                      title: `FaveBack - ${props.title}`,
                      url: requestUrl,
                    }}
                  />
                  <a
                    href={requestUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center border border-mauve-300 bg-mauve-700 px-3 py-2 text-white hover:bg-mauve-800"
                  >
                    <IconExternalLink className="size-4" />
                  </a>
                </div>
              </div>
            </div>

            {hasPayload(props.payload) ? (
              <div>
                <small className="text-mauve-500">Picks</small>
                <div className="mt-1 flex">
                  <textarea
                    readOnly
                    value={formatPayload(props.payload)}
                    ref={requestPayloadRef}
                    className="min-h-24 min-w-0 flex-1 border border-r-0 border-mauve-200 bg-white px-3 py-2 text-sm text-mauve-900"
                  />
                  <div className="flex shrink-0 self-stretch [&>*]:h-full [&>*+*]:border-l-0">
                    <RequestItemShareButton
                      copyOnly
                      shareData={{
                        text: formatPayload(props.payload),
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
